export function useExternalRedirect() {
  const currentUrl = useRequestURL();

  return {


    setAmbassadorCookie(ambId) {
      const domain = getDomain();
      useCookie('ambassador_id', {
        maxAge: 86400,
        sameSite: 'lax',
        secure: !!domain,
        ...(domain ? { domain } : {}),
        path: '/'
      }).value = ambId;
    },

    setSignupCookie({type = 'referral', value, context = 'share'}) {
      const domain = getDomain();
      useCookie('sign_up', {
        maxAge: 86400, //1 days
        sameSite: 'lax',
        secure: !!domain,
        ...(domain ? { domain } : {}),
        path: '/'
      }).value = {type, value, context};
    },

    setRedirectCookie(redirectTo) {
      if (redirectTo) {
        const redirectValue = typeof redirectTo === 'string'
          ? `${window.location.protocol}//${window.location.host}${redirectTo}`
          : window.location.href;

        //set session cookie
        useCookie('redirect_to').value = redirectValue;
      }
    },

    signUp(redirectTo) {
      if (redirectTo) {
        this.setRedirectCookie(redirectTo);
      }

      window.location = EXTERNAL_URLS.signUp;
    },

    /**
     * @param userId
     * @param id - the product to add to cart
     * @param category - can be projects or jupiter
     * @param isUserAuthenticated
     * @param promotionCode
     */
    addToCart({userId, id, category = 'projects', isUserAuthenticated, promotionCode}) {
      const url = buildRouteParams(EXTERNAL_URLS.addToCart, {userId, category, id});
      const queryString = buildQueryString({code: promotionCode});
      const destUrl = `${url}${queryString}`;

      if (isUserAuthenticated) {
        window.location = destUrl;
      } else {
        this.signUp(destUrl);
      }
    }
  };
}
